const creditCardNumberValidation = (NumeroTarjeta) => {
	var sum = 0, alt = false, i = NumeroTarjeta.length-1, num;
	if (NumeroTarjeta === null || (isNaN(NumeroTarjeta) === true) ){
		return false;
	}
	if (NumeroTarjeta.length < 13 || NumeroTarjeta.length > 19){
		return false;
	}
	while (i >= 0){
		num = parseInt(NumeroTarjeta.charAt(i), 10);
		if (isNaN(num)){
			return false;
		}
		if (alt){
			num *= 2;
			if (num > 9){
				num = (num % 10) + 1;
			}
		}
		alt = !alt;
		sum += num;
		i--;
	}
	if (sum % 10 === 0 && sum !== 0){
		//Tarjeta v�lida
		return true;
	}
	else{
		//Tarjeta inv�lida
		return false;
	}
}

export default creditCardNumberValidation